module.exports = __webpack_public_path__ + "img/morgner.901605c4.jpeg";